/*export enum PlayerAnimationDirections {
    Down = "down",
    Left = "left",
    Up = "up",
    Right = "right",
}*/
export enum PlayerAnimationTypes {
    Walk = "walk",
    Idle = "idle",
}

export interface AnimationData {
    key: string;
    frameRate: number;
    repeat: number;
    frameModel: string; //todo use an enum
    frames: number[];
}

/**
 * INSECAP: las hojas de personaje tienen cinco columnas por dirección en vez de
 * tres (ver scripts/respirar_woka.py):
 *
 *     [paso] [reposo] [paso] [respira] [parpadea]
 *
 * "respira" es el reposo con el cuerpo bajado un píxel y las piernas quietas;
 * "parpadea" es el reposo con los ojos cerrados (solo cambia en la capa de los
 * ojos, el resto de las capas repiten el reposo).
 *
 * El reposo original era un solo fotograma con repeat 1: el personaje se
 * quedaba congelado como una estatua. Ahora es un ciclo de dos segundos a diez
 * fotogramas por segundo, que es lo que permite mezclar tiempos distintos con
 * un solo frameRate: 800 ms quieto, 100 ms de parpadeo, 100 ms quieto y un
 * segundo respirando.
 */
const COLUMNAS = 5;
const REPOSO = 1;
const RESPIRA = 3;
const PARPADEA = 4;

function caminata(base: number): number[] {
    return [base, base + 1, base + 2, base + 1];
}

function reposo(base: number): number[] {
    const quieto = base + REPOSO;
    return [
        ...Array<number>(8).fill(quieto),
        base + PARPADEA,
        quieto,
        ...Array<number>(10).fill(base + RESPIRA),
    ];
}

const DIRECCIONES = ["down", "left", "right", "up"];

export function getPlayerAnimations(name: string): AnimationData[] {
    return DIRECCIONES.flatMap((direccion, fila) => {
        const base = fila * COLUMNAS;
        return [
            {
                key: `${name}-${direccion}-${PlayerAnimationTypes.Walk}`,
                frameModel: name,
                frames: caminata(base),
                frameRate: 10,
                repeat: -1,
            },
            {
                key: `${name}-${direccion}-${PlayerAnimationTypes.Idle}`,
                frameModel: name,
                frames: reposo(base),
                frameRate: 10,
                repeat: -1,
            },
        ];
    });
}
